module.exports = __webpack_public_path__ + "img/sec-225-ibk.4d625e9a.svg";